import React, { useEffect, useContext, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { SwapVolumeTCVsExternal } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getCompetitorsPctSwapVolumeConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'defillama_dex_swap_volumes', timeframe)) as SwapVolumeTCVsExternal[]
	const thorchainData = chartData.filter((row) => row.LABEL === 'thorchain-dex')
	const nearData = chartData.filter((row) => row.LABEL === 'near-intents')
	const chainflipData = chartData.filter((row) => row.LABEL === 'chainflip')

	let series1,
		series2,
		series3: {
			x: number
			y: number
		}[] = []

	if (timeframe === '1w' || timeframe === '1d') {
		series1 = thorchainData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series2 = nearData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series3 = chainflipData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
	} else {
		//(timeframe === '1m')
		series1 = thorchainData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series2 = nearData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series3 = chainflipData.map((element: SwapVolumeTCVsExternal) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
	}

	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THORChain',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: 'green',
			unitSymbol: '%',
			barGroup: 'usd'
		},

		{
			data: series2,
			strokeWidth: 2,
			name: 'Near Intents',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: 'orange',
			unitSymbol: '%',
			barGroup: 'usd'
		},

		{
			data: series3,
			strokeWidth: 2,
			name: 'Chainflip',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: '#e0969b',
			unitSymbol: '%',
			barGroup: 'usd'
		}
	]

	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const CompetitorsPctSwapVolume = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getCompetitorsPctSwapVolumeConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Competitors % Of Total Swap Volume"
			chartDesc={`THORChain’s share of total cross-chain / DEX swap volume relative to competing platforms. Data from Defillama.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="66b87c85-7b06-495b-baca-651d51578068"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasDays={false}
			sortByValueDesc={true}
			startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 12}
		/>
	)
}

export default CompetitorsPctSwapVolume
